// removed by extract-text-webpack-plugin
module.exports = {"testimonialSection":"_0n-qPfe_mBRxAxI5jBuo","name":"xnifoY4hfngd12fTtw8lA","title":"_1_PWeZBC0G9NaL6i50Ev6Q","content":"_1Y4HbeRcyx12PJn_EmglCg"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/TestimonialSection.scss
// module id = 1612
// module chunks = 0